module.exports = __webpack_public_path__ + "static/media/landingPage_Patient.40147000.md";